module.exports = __webpack_public_path__ + "img/vino-logo-dark.5a64af4a.svg";